import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import SideMenu, {
  SideMenuTitle,
  SideMenuLink,
  SideMenuSpacer,
} from '@amzn/meridian/side-menu';
import Heading from '@amzn/meridian/heading';
import { InRole } from '@amzn/dots-core-ui';
import { ProjectUri, RootUri } from './routes';

export const AppNavigation = ({
  isMenuOpen,
}: {
  isMenuOpen: boolean;
}): JSX.Element => {
  const history = useHistory();
  const location = useLocation();
  const pathStartsWith = (test: string): boolean =>
    location.pathname.substring(0, test.length) === test;
  const menuOptions = (item: any) => {
    if (!item.role || InRole(item.role))
      return (
        <SideMenuLink
          key={item.title}
          href={item.path}
          onClick={history.push}
          selected={pathStartsWith(item.path)}
        >
          {item.title}
        </SideMenuLink>
      );
    return null;
  };
  return (
    <SideMenu width={225} open={isMenuOpen}>
      <SideMenuTitle href={RootUri} onClick={history.push}>
        <Heading level={4}>Storage</Heading>
      </SideMenuTitle>
      {[
        { title: 'Favorites', path: RootUri },
        { title: 'Projects', path: ProjectUri },
      ].map(menuOptions)}
      <SideMenuSpacer />
    </SideMenu>
  );
};
